import { injectable } from "inversify";
import { IOption } from "../../components/inputs/select-dropdown/select-dropdown";
import { IDefaultOfferRanges, IResolution, IResolutionCategory } from "../../models/ResolutionTypes";
import { rootContainer, TYPE } from "../container/root";
import { IApiResponse, IHttpService } from "../http-service";
import { REFUND_BY, RESOLUTION_TYPE } from "../../pages/resolutions/constants";
import {WithOld} from "../../stores/types";


export interface IResolutionData {
    resolutions: IResolutionCategory[],
    settings: IResolutionSettings,
}

interface IResolutionsService {
    getResolutionsList: () => Promise<IResolutionData>,
}

export interface IExchangeRefundProviderOption extends IOption {
    refund_by: REFUND_BY,
}

export interface IRefundProviderOption extends IOption {
    resolution_type: RESOLUTION_TYPE,
}

export interface IResolutionSettings {
    exchange_refund_by_list: IOption[],
    exchange_refund_by_providers: IExchangeRefundProviderOption[],
    refund_types: IOption[];
    default_offer_ranges: IDefaultOfferRanges,
    refund_service_providers: IRefundProviderOption[],
    allow_out_of_stock_exchange_options: IOption[],
}


@injectable()
class ResolutionsService implements IResolutionsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async getResolutionsList(): Promise<IResolutionData> {
        const res = await this.httpService.get<IApiResponse<IResolutionData>>(`/rms-api/resolutions`);
        return res.payload;
    }

    async updateResolution(resolutionId:number, resolution: WithOld<IResolution>): Promise<IResolution> {
        const res = await this.httpService.put<IApiResponse<IResolution>>(`/rms-api/resolutions/${resolutionId}`, resolution);
        return res.payload;
    }

    async createResolution(resolution: IResolution): Promise<IResolution> {
        const res = await this.httpService.post<IApiResponse<IResolution>>(`/rms-api/resolutions`, resolution);
        return res.payload;
    }

    async deleteResolution(resolutionId:number): Promise<IResolution> {
        const res = await this.httpService.remove<IApiResponse<IResolution>>(`/rms-api/resolutions/${resolutionId}`);
        return res.payload;
    }
}

export default ResolutionsService;